<template lang="pug">
    .flex(class="flex-col gap-5 w-full 1024:w-400")
        app-text-block
            app-greeting
            p(v-if="isDone === 'not'")
                | Это 
                b {{ stationTitle }}
                |  и мы безумно рады, что именно ты стал победителем. Для получения приза заполни форму ниже.
            p(v-else-if="isDone === 'yes'") Ваши данные отправлены. Мы скоро свяжемся с вами.
            p(v-else-if="loadError") Не удалось открыть анкету. Попробуйте ещё раз.
            p(v-else) Открываем анкету...

        app-button.w-full(v-if="loadError" :loading="loading" @click="onLoadProfile")
            template Повторить
        
        template(v-if="isDone === 'not'")
            profile-form.w-full
</template>

<script>
//Components
import ProfileForm from './components/form'
import TextBlock from '@/components/common/text-block'
import Greeting from '@/components/common/greeting'
import Button from '@/components/common/button'
//Store
import { ProfileNameSpace, ProfileActionTypes } from '@/store/profile/types';
import { RootGetterTypes } from '@/store/types';

export default {
    name: "account-component",
    components: {
        'profile-form': ProfileForm,
        'app-text-block': TextBlock,
        'app-greeting': Greeting,
        'app-button': Button,
    },
    data() {
        return {
            isDone: '',
            loadError: false,
            loading: false,
        }
    },
    computed: {
        ORIGIN() {
            return this.$store.getters[`${RootGetterTypes.GetOrigin}`]
        },
        stationTitle() {
            const titles = {
                HITFM: 'Хит ФМ',
                DFM: 'DFM',
                MAXIMUM: 'Maximum',
                MONTECARLO: 'Monte Carlo',
                RUSRADIO: 'Русское Радио',
                RU: 'RU TV',
                LOCALHOST: 'RU TV',
            }
            return titles[this.ORIGIN] || 'наша станция'
        },
    },
    async mounted() {
        await this.onLoadProfile()
    },
    methods: {
        wait(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms))
        },
        async onLoadProfile() {
            if (this.loading) {
                return
            }
            this.loading = true
            this.loadError = false
            this.isDone = ''
            try {
                for (let attempt = 0; attempt < 3; attempt++) {
                    try {
                        const response = await Promise.race([
                            this.$store.dispatch(`${ProfileNameSpace}/${ProfileActionTypes.GetProfile}`),
                            this.wait(8000).then(() => {
                                throw new Error('profile timeout')
                            }),
                        ])
                        const profile = response && response.data && response.data.data && response.data.data.profile
                        if (profile === 0 || profile === 1) {
                            this.isDone = profile === 0 ? 'not' : 'yes'
                            return
                        }
                    } catch (error) {
                        // Следующая попытка ниже.
                    }
                    if (attempt < 2) {
                        await this.wait(400)
                    }
                }
                this.loadError = true
            } finally {
                this.loading = false
            }
        },
    },
}
</script>